/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserStatsDto } from '../../models/user-stats-dto';

export interface GetUserStats$Params {
  userId: number;
  'X-API-Version'?: string;
}

export function getUserStats(http: HttpClient, rootUrl: string, params: GetUserStats$Params, context?: HttpContext): Observable<StrictHttpResponse<UserStatsDto>> {
  const rb = new RequestBuilder(rootUrl, getUserStats.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserStatsDto>;
    })
  );
}

getUserStats.PATH = '/api/user-stats/{userId}';
